var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.831,
    height: 30.686,
    viewBox: "0 0 32.831 30.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2983",
    "data-name": "Group 2983",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M308.3,509.457a1.317,1.317,0,0,1-1.318-1.317,8.506,8.506,0,0,0-5.383-7.938,14.3,14.3,0,0,1-16.4,0,8.508,8.508,0,0,0-5.38,7.938,1.318,1.318,0,0,1-1.318,1.317h0a1.318,1.318,0,0,1-1.318-1.318,11.135,11.135,0,0,1,7.842-10.67,1.32,1.32,0,0,1,1.2.217,11.671,11.671,0,0,0,14.339,0,1.324,1.324,0,0,1,1.2-.218,11.134,11.134,0,0,1,7.844,10.67A1.318,1.318,0,0,1,308.3,509.457Z",
    transform: "translate(-277.182 -479.17)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M295.668,491.753a9.281,9.281,0,1,1,9.282-9.281A9.292,9.292,0,0,1,295.668,491.753Zm0-15.927a6.646,6.646,0,1,0,6.646,6.646A6.653,6.653,0,0,0,295.668,475.826Z",
    transform: "translate(-279.454 -473.19)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.7246eadf778f99b2d7435734c9669ae5.svg";
export { ForwardRef as ReactComponent };